/**
 * @file: 框选
 * @author: xiaolong.huang@dmall.com
 */

import * as SelectToolkit from './toolkit';
import * as CubeTree from '../../cubeTree/index';
import * as UIToolkit from '../../UIToolkit/index';
import CodiSystem from '../../codiSystem/index';
import DrawRect from '../drawRect/index';
import Message from './message';

function byRect(rect: Rect): void {
    // 把框选矩形框坐标传入坐标系统，获取在这个边界内的所有cubeid
    let allCubeIds: CubeId[] = CubeTree.getAllCube();
    let queryCubes: CubeId[] = allCubeIds.filter((cubeId: CubeId): boolean => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        return SelectToolkit.canSelect(cube);
    });
    let beContainCubeIds: Array<CubeId> = CodiSystem.filterByTargetPaintRect({
        ...rect
    }, queryCubes);

    // 先清空之前的选择内容
    SelectToolkit.clearAllSelect();

    // 把筛选出的cube添加到选择器中
    if (beContainCubeIds.length >= 60) {
        UIToolkit.showLoading();
        setTimeout(() => {
            SelectToolkit.addGroup(beContainCubeIds);
            Message.panelSelectAsync();
            UIToolkit.hideLoading();
        }, 10);
        return;
    }

    SelectToolkit.addGroup(beContainCubeIds);
    Message.panelSelectAsync();
}

export {
    byRect
}
